// /api/evolution-plan/get-evolution-plan-employees/:serviceType

import { api } from "api";

export const getEvolutionPlanEmployees = (
  serviceType,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/evolution-plan/get-evolution-plan-employees/${serviceType}`)
      .then((res) => {
        dispatch({
          type: "GET_EVOLUTIONPLAN_EMPLOYEES_SUCCESS",
          payload: res.data.data.employees,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_EVOLUTIONPLAN_EMPLOYEES_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getEvolutionPlans = (employeeId, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/evolution-plan/get-evolution-plans/${employeeId}`)
      .then((res) => {
        dispatch({
          type: "GET_EVOLUTIONPLANS_FOR_EMPLOYEE_SUCCESS",
          payload: res.data.data.evolutionPlans,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_EVOLUTIONPLANS_FOR_EMPLOYEE_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getEvolutionPlanTrainingPreRequisites = (
  trainingId,
  employeeId,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(
        `/api/evolution-plan/get-training-prerequisites/${trainingId}/${employeeId}`
      )
      .then((res) => {
        dispatch({
          type: "GET_EVOLUTIONPLANS_PREREQ_SUCCESS",
          payload: res.data,
        });

        onSuccess(res.data);
      })
      .catch((e) => {
        dispatch({
          type: "GET_EVOLUTIONPLANS_PREREQ_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getEvolutionPlanCompletionRatio = (
  employeeId,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(
        `/api/evolution-plan/get-evolution-plan-training-completion-ratio/${employeeId}`
      )
      .then((res) => {
        dispatch({
          type: "GET_EVOLUTIONPLAN_COMPLETION_RATIO_SUCCESS",
          payload: res.data.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: "GET_EVOLUTIONPLAN_COMPLETION_RATIO_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};
